import { useEffect, useState } from 'react';
import api from '../services/api';

// Fetches the daily portfolio-value snapshot series (replaces the old
// transaction-derived value history when TRANSACTIONS_ENABLED is off).
// Response shape from the server:
//   [{ date: 'YYYY-MM-DD', totalValueUsd: number }, ...]
export function usePortfolioSnapshotHistory(days = 30) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get(`/api/portfolio/snapshot-history?days=${days}`);
        if (!cancelled) {
          setData(Array.isArray(res.data) ? res.data : []);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.error || err.message);
          setData([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [days]);

  return { data, loading, error };
}
